/* ============================================================
   BLUE BISON - 40% OFF SALE PRICE DISPLAY OVERRIDE
   ============================================================
   This script visually displays all prices at 40% off.
   The actual discount is applied at checkout via Shopify's
   automatic discount. This is display-only.
   
   TO DISABLE: Set SALE_ACTIVE to false below.
   ============================================================ */

(function() {
  'use strict';
  
  // ==========================================
  // TOGGLE - SET TO false TO DISABLE THE SALE
  // ==========================================
  const SALE_ACTIVE = true;
  const DISCOUNT_PERCENT = 0.40; // 40% off
  
  if (!SALE_ACTIVE) return;
  
  const MULTIPLIER = 1 - DISCOUNT_PERCENT; // 0.6
  
  // Track elements we've already processed to avoid double-discounting
  const PROCESSED_ATTR = 'data-sale-processed';
  
  // ==========================================
  // PRICE PARSING HELPERS
  // ==========================================
  
  // Extract a dollar amount from a string like "$25" or "$25.99"
  // Returns { prefix, amount, suffix } or null if no match
  function parsePrice(text) {
    const match = text.match(/^(.*?)\$(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return null;
    return {
      prefix: match[1],
      amount: parseFloat(match[2]),
      suffix: match[3]
    };
  }
  
  // Format a number back to "$X" or "$X.XX"
  function formatPrice(amount) {
    return amount % 1 === 0 ? '$' + Math.round(amount) : '$' + amount.toFixed(2);
  }
  
  // Apply 40% off to a dollar amount
  function discount(amount) {
    return amount * MULTIPLIER;
  }
  
  // ==========================================
  // PROCESSORS FOR DIFFERENT PRICE PATTERNS
  // ==========================================
  
  // Standard single-price element: "$30" -> "$18"
  function processSimplePrice(el) {
    if (el.hasAttribute(PROCESSED_ATTR)) return;
    
    const text = el.textContent.trim();
    
    // Skip "SOLD OUT", empty, or non-price text
    if (!text.includes('$')) return;
    
    const parsed = parsePrice(text);
    if (!parsed) return;
    
    const newAmount = discount(parsed.amount);
    el.textContent = parsed.prefix + formatPrice(newAmount) + parsed.suffix;
    el.setAttribute(PROCESSED_ATTR, 'true');
  }
  
  // Price element that may contain a child compare-at price
  // Pattern: <p class="price"><span class="compare">$40</span> $30</p>
  // After: compare = original compare ($40), main = 40% off original compare ($24)
  // If no compare exists, just discount the main price
  function processPriceWithCompare(priceEl, compareSelector) {
    if (priceEl.hasAttribute(PROCESSED_ATTR)) return;
    
    const compareEl = priceEl.querySelector(compareSelector);
    
    if (compareEl && !compareEl.hasAttribute(PROCESSED_ATTR)) {
      // Has a compare-at price - "deeper discount" mode
      // Strikethrough stays at original compare-at
      // Main price becomes 40% off the compare-at (deeper than the original sale)
      const compareText = compareEl.textContent.trim();
      const compareParsed = parsePrice(compareText);
      
      if (!compareParsed) return;
      
      // The compare price stays as the strikethrough (don't change)
      compareEl.setAttribute(PROCESSED_ATTR, 'true');
      
      // The new sale price = 40% off the compare-at
      const newSalePrice = discount(compareParsed.amount);
      
      // Find the main price text node (everything after the compare span)
      // We need to replace the text content while preserving the compare span
      const compareHtml = compareEl.outerHTML;
      const formattedNew = formatPrice(newSalePrice);
      
      // Rebuild: keep compare span, replace remaining text with new price
      priceEl.innerHTML = compareHtml + '  ' + formattedNew;
      priceEl.setAttribute(PROCESSED_ATTR, 'true');
      
    } else {
      // No compare price - just discount the displayed price
      // But we want to ADD a compare-at to show it's on sale
      const text = priceEl.textContent.trim();
      
      // Skip if it's "SOLD OUT" or similar
      if (text.toUpperCase().includes('SOLD OUT')) return;
      
      const parsed = parsePrice(text);
      if (!parsed) return;
      
      const originalPrice = parsed.amount;
      const newPrice = discount(originalPrice);
      
      // We need to detect what kind of compare span class this site uses
      // Pass it in via compareSelector (e.g. ".bb-search-product__price-compare")
      const compareClass = compareSelector.replace(/^\./, '');
      
      priceEl.innerHTML = '<span class="' + compareClass + '">' + formatPrice(originalPrice) + '</span> ' + formatPrice(newPrice);
      priceEl.setAttribute(PROCESSED_ATTR, 'true');
    }
  }
  
  // Process a button/element where the price is embedded in other text
  // e.g. "CHECKOUT $50 USD" -> "CHECKOUT $30 USD"
  // e.g. "ADD TO CART $30" -> "ADD TO CART $18"
  // e.g. "$5 AWAY FROM FREE SHIPPING" -> recalc against discounted total
  function processEmbeddedPrice(el) {
    if (el.hasAttribute(PROCESSED_ATTR)) return;
    
    const text = el.textContent;
    
    // Find all $X or $X.XX patterns in the text and discount them
    const newText = text.replace(/\$(\d+(?:\.\d+)?)/g, function(match, amount) {
      const discounted = discount(parseFloat(amount));
      return formatPrice(discounted);
    });
    
    if (newText !== text) {
      el.textContent = newText;
      el.setAttribute(PROCESSED_ATTR, 'true');
    }
  }
  
  // ==========================================
  // MAIN PROCESSOR - runs across the page
  // ==========================================
  
  function processAllPrices() {
    
    // ----- HOME PAGE (all carousel sections s1-s10) -----
    document.querySelectorAll('[class*="home-s"][class*="__price"]').forEach(function(el) {
      // Skip if this is a compare-price span (child element)
      if (el.className.indexOf('__compare-price') !== -1) return;
      // Skip if sold out
      if (el.className.indexOf('__price--sold-out') !== -1) return;
      
      // Figure out which section this is (s1, s2, s3, etc.) to find the right compare selector
      const match = el.className.match(/home-(s\d+)__price/);
      if (!match) return;
      const sectionPrefix = match[1]; // "s1", "s2", etc.
      const compareSelector = '.home-' + sectionPrefix + '__compare-price';
      
      processPriceWithCompare(el, compareSelector);
    });
    
    // ----- SEARCH / COLLECTION GRID -----
    document.querySelectorAll('.bb-search-product__price').forEach(function(el) {
      if (el.classList.contains('bb-search-product__price--sold-out')) return;
      processPriceWithCompare(el, '.bb-search-product__price-compare');
    });
    
    // ----- PRODUCT OVERLAY: Handled internally by product-overlay.liquid -----
    // The product overlay applies its own 40% sale pricing inline when rendering.
    // We skip those elements here to avoid double-discounting and flash on re-renders.
    
    // ----- PRODUCT OVERLAY: Related products -----
    document.querySelectorAll('.bb-product-related-price').forEach(function(el) {
      if (el.textContent.toUpperCase().includes('SOLD OUT')) return;
      processPriceWithCompare(el, '.bb-product-related-compare-price');
    });
    
    // ----- CART: Item prices -----
    document.querySelectorAll('.bb-cart-item__price').forEach(function(el) {
      processSimplePrice(el);
    });
    
    // ----- CART: Handled internally by cart-overlay.liquid -----
    // The cart overlay applies its own 40% sale pricing for the total and free shipping math.
    // We skip those elements here to avoid double-discounting.
    
  }
  
  // ==========================================
  // OBSERVERS - re-run when DOM changes
  // ==========================================
  
  // Use MutationObserver to catch dynamically-rendered prices
  // (cart re-renders, search results, product overlay, etc.)
  const observer = new MutationObserver(function(mutations) {
    let shouldProcess = false;
    
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldProcess = true;
        break;
      }
    }
    
    if (shouldProcess) {
      // Debounce - wait a tick for the render to finish
      clearTimeout(window._salePriceTimeout);
      window._salePriceTimeout = setTimeout(processAllPrices, 50);
    }
  });
  
  // Start observing once DOM is ready
  function init() {
    processAllPrices();
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();